import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { paramDeger } from '@/src/app/shared/utils/param-deger.utils';

@Component({
  selector: 'musteri-kart-sade',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="ui text-center fluid pb-2">
      <div class="ui primary label mini"> Müşteri Tanımı </div>
    </div>
    <div class="sk" style="--sk-accent:#13c2c2">
      @if (deger('logo')) {
        <img [src]="deger('logo')" style="width:40px;height:40px;border-radius:8px;object-fit:cover;flex-shrink:0" />
      } @else {
        <span style="font-size:28px;flex-shrink:0">🏢</span>
      }
      <div class="sk-icerik">
        <div class="sk-baslik">{{ deger('firmaAdi') || 'Isimsiz Musteri' }}</div>
        @if (deger('yetkili')) { <div class="sk-alt">{{ deger('yetkili') }}</div> }
        @if (deger('sektor')) { <span class="sk-chip">{{ deger('sektor') }}</span> }
      </div>
    </div>
  `,
})
export class MusteriKartSadeComponent extends FikoYTKokBilesenComponent {
  parametreler = input<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
  deger(alan: string): any { return paramDeger(this.p(), alan); }
}
